module.exports = __webpack_public_path__ + "69a2aedf8b497d826860ac02e03ae7f4.svg";